/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (connectionId = null) => (dispatch) => {
    return cecSdk
        .connection(connectionId)
        .getSalesMeta()
        .then((response) => {
            return response;
        });
};
